import { useLocation, matchPath } from 'react-router-dom';
import { routes } from '../utils/routesMap';
import capitalizeWords from '../utils/capitalizeWords';

const useBreadcrumbs = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(Boolean);

  const breadcrumbs = pathnames.map((_, index) => {
    const currentPath = `/${pathnames.slice(0, index + 1).join('/')}`;

    const route = routes.find(({ path }) => matchPath({ path, end: true }, currentPath));
    if (!route) return null;

    const routeSegments = route.path.split('/').filter(Boolean);
    const currentSegments = currentPath.split('/').filter(Boolean);

    const breadcrumb = route.breadcrumb
      .split(' ')
      .map((segment, i) => {
        if (segment.startsWith(':')) {
          const paramIndex = routeSegments.findIndex((seg) => seg === segment);
          return capitalizeWords(currentSegments[paramIndex]?.replace(/-/g, ' '));
        }
        return capitalizeWords(segment);
      })
      .join(' ');

    return { breadcrumb, path: currentPath };
  });

  return breadcrumbs.filter(Boolean);
};

export default useBreadcrumbs;
